import { render, staticRenderFns } from "./Shenhe2.vue?vue&type=template&id=17faf1d6&scoped=true"
import script from "./Shenhe2.vue?vue&type=script&lang=js"
export * from "./Shenhe2.vue?vue&type=script&lang=js"
import style0 from "./Shenhe2.vue?vue&type=style&index=0&id=17faf1d6&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17faf1d6",
  null
  
)

export default component.exports